/**
 * application 相关存储信息
 *   menuCollapse 导航是否收缩
 *   navigation   面包屑导航
 *   loading      加载中蒙版
 */
import axios from 'assets/js/myAxios'

const app = {
  state: {
    menuCollapse: localStorage.getItem('collapse') === 'true',
    navigation: [],
    loading: false
  },
  mutations: {
    MENU_COLLAPSE: (state) => {
      state.menuCollapse = !state.menuCollapse
      localStorage.setItem('collapse', state.menuCollapse)
    },
    SET_NAVIGATION: (state, data) => {
      state.navigation = data
    },
    SET_LOADING: (state, data) => {
      state.loading = data
    }
  },
  actions: {
    toggleMenu: ({ commit }) => {
      commit('MENU_COLLAPSE')
    },
    setNavigation: ({ commit }, navigation) => {
      commit('SET_NAVIGATION', navigation)
    },
    setCourseNav: ({ commit }, param) => {
      let navs = []
      return new Promise((resolve, reject) => {
        axios.get('/course/crumb?id=' + param.id + '&idType=' + param.idType)
          .then(response => {
            if (response.pname) {
              navs.push({name: response.pname})
            }
            if (response.uid && response.uname) {
              navs.push({name: response.uname, path: param.idType === 1 ? '' : '/course/unit/' + response.uid})
            }
            if (response.gid && response.gname) {
              navs.push({name: response.gname, path: param.idType === 2 ? '' : '/course/grade/' + response.gid})
            }
            if (response.cname) {
              navs.push({name: response.cname})
            }
            resolve(response)
          })
          .catch((error) => {
            console.log(error)
            // reject(error)
          })
          .then(() => {
            commit('SET_NAVIGATION', navs)
          })
      })
    },
    setLoading: ({ commit }, loading) => {
      if (typeof loading === 'undefined') {
        loading = true
      }
      commit('SET_LOADING', loading)
    }
  }
}

export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js